/** Ten sam wzorzec, którego pilnuje backend (`@Pattern(^#[0-9A-Fa-f]{6}$)`). */
export const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;
